/* eslint-disable no-param-reassign */
export default {
  mounted(el, binding) {
    el.addEventListener('scroll', event => {
      if (binding.modifiers.self && event.target !== el) return;
      binding.value(event);
    });
  },
  unmounted(el, binding) {
    el.removeEventListener('scroll', binding.value);
  },
};
